import MarkdownIt from 'markdown-it';
import taskLists from 'markdown-it-task-lists';

export function createMarkdownRenderer(): MarkdownIt {
  const renderer = new MarkdownIt({
    html: false,
    linkify: true,
    breaks: true,
    typographer: true,
  });
  renderer.use(taskLists, { enabled: true, label: true, labelAfter: true });
  return renderer;
}
